import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

// Company-page step 1 (Details form) - see company-page.component.ts for the
// confirmed data-step -> TypeOfCompany mapping this component implements.
@Component({
  selector: 'app-company-page-step-details',
  templateUrl: './company-page-step-details.component.html'
})
export class CompanyPageStepDetailsComponent implements AfterViewInit, OnDestroy {

  @Input() typeOfCompany: string;
  @Input() hostCompanySelected: boolean;
  @Input() companyManagement: any = {};
  @Input() companyTypes: any[] = [];
  @Input() companyDetailsUpdateMode: boolean;
  @Input() isStaffingAdmin: boolean;
  @Input() isAssociatedClientUpdateInProgress: boolean;
  @Input() clientOrBuUpdateInProgress: boolean;
  @Input() savedCompanyManagement: any = {};
  @Input() geoLocations: any[] = [];
  @Input() isCountyExists: boolean;
  @Input() validzipcode: boolean;
  @Input() cancelNotClicked: boolean;
  @Input() step1FormSubmitted: boolean;

  @Output() addressFieldChangeCallback = new EventEmitter<{ type: string, value: any }>();
  @Output() zipcodeBlurCallback = new EventEmitter<string>();
  @Output() toggleCopyCompanyAddressCallback = new EventEmitter<void>();
  @Output() voiceTranscriptCallback = new EventEmitter<string>();
  @Output() formalizedCommentCallback = new EventEmitter<string>();
  @Output() formStateChange = new EventEmitter<any>();

  @ViewChild('companyDetailsForm') companyDetailsForm: NgForm;

  MESSAGECONSTANTS = MESSAGECONSTANTS;
  focused: any = {};

  private statusSub: Subscription;

  ngAfterViewInit() {
    // Bridge the native template-driven form's status back into a plain
    // object shaped like the AngularJS FormController the legacy root
    // controller still reads ($valid / zipcode.$valid / $setPristine()) -
    // company-page.component.js combines this with other still-legacy
    // step forms' $valid before allowing wizard navigation.
    setTimeout(() => this.emitFormState());
    this.statusSub = this.companyDetailsForm.statusChanges.subscribe(() => this.emitFormState());
  }

  ngOnDestroy() {
    if (this.statusSub) {
      this.statusSub.unsubscribe();
    }
  }

  private emitFormState() {
    if (!this.companyDetailsForm) {
      return;
    }
    const form = this.companyDetailsForm;
    const zipcodeControl = form.controls['zipcode'];
    // A vendor's fields are all disabled, which makes the form status DISABLED and
    // `valid` false, so test `invalid` instead (AngularJS `$valid` ignored disabled controls).
    this.formStateChange.emit({
      $valid: !form.invalid,
      $dirty: form.dirty,
      zipcode: { $valid: zipcodeControl ? !zipcodeControl.invalid : false },
      $setPristine: () => form.form.markAsPristine()
    });
  }

  get cities() {
    return this.uniqueBy(this.geoLocations, 'city');
  }

  get states() {
    return this.uniqueBy(this.geoLocations, 'state');
  }

  get counties() {
    return this.uniqueBy(this.geoLocations, 'county');
  }

  get countries() {
    return this.uniqueBy(this.geoLocations, 'country');
  }

  private uniqueBy(collection: any[], keyName: string) {
    const output = [];
    const keys = [];
    (collection || []).forEach((item) => {
      const key = item[keyName];
      if (keys.indexOf(key) === -1) {
        keys.push(key);
        output.push(item);
      }
    });
    return output;
  }

  onAddressFieldChange(type: string, value: any) {
    this.addressFieldChangeCallback.emit({ type, value });
  }

  onZipcodeBlur() {
    this.zipcodeBlurCallback.emit(this.companyManagement.company.zipcode);
  }

  onToggleCopyCompanyAddress() {
    this.toggleCopyCompanyAddressCallback.emit();
  }

  onVoiceTranscript(transcript: string) {
    this.voiceTranscriptCallback.emit(transcript);
  }

  onFormalizedComment(comment: string) {
    this.formalizedCommentCallback.emit(comment);
  }
}
